<template>
  <div class="zg-fund-contract-detail blue-avue-form">
    <div class="inner-con" >
      <div class="project-title" v-if="isDetail">{{basicInfoData.dzContractVO.contractName}}</div>
      <div class="project-status" v-if="isDetail">
        <div class="status-title">审批状态</div>
        <div class="status-content" :class="['stateTopdiv', 'color_' + basicInfoData.auditStatus]">
          {{basicInfoData.auditStatusStr}}
        </div>
      </div>

      <el-tabs v-model="activeName">
        <el-tab-pane class="activelabel" label="项目详情" name="first">
          <InfoContainer
            id="basicForm"
            style="margin-top:20px;"
            :infoTitle="InfoContainerConfig['infoTitle']"
            :contentConfig="InfoContainerConfig['infoContent']"
          >
            <template slot="basicInfo">
              <avue-form
                ref="basicInfo"
                v-model="basicInfoData"
                :option="formConfig"
              >
                <template #projectName>
                  <CommonSelect
                    bindLabel="contractName"
                    bindKey="id"
                    bindValue="contractName"
                    methods="get"
                    dataMethod="params"
                    dataUrl="dz/dzcontract/page"
                    searchKey="contractName"
                    placeholder="请选择项目"
                    :initParam="{auditStatus: 2}"
                    :bindId="contractId?contractId:''"
                    @handleChange="setProjectData"
                  />
                </template>
              </avue-form>
            </template>

          </InfoContainer>

          <!-- 流程公共附件 -->
          <Accessory
            v-loading="!dataReady"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(153, 153, 153, 0.8)"
            v-if="uploadPermissionNameOne && uploadPermissionNameTwo"
            :idname="uploadPermissionNameTwo"
            :fileMenuUrlname="uploadPermissionNameOne"
            :projectid="fileId"
            :dynamicId="id"
            :upload="true"
            :permissionList="permissionList"
            :isPermission="true"
          />

          <!-- 流程设计审批信息表单 -->
          <AuditInfo
            ref="auditInfo"
            v-loading="!dataReady"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(153, 153, 153, 0.8)"
            v-if="isStartedProcess && auditFormData && auditFormData != {}"
            :formDetailData="auditFormData"
            :isEditable="processDetail.process?processDetail.process.isEditable:false"
            :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
          />

          <!-- 会签意见区 -->
          <CommentStep
            v-loading="!dataReady"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(153, 153, 153, 0.8)"
            v-if="commentList.length > 0"
            :commentList="commentList"
            :taskSaveData="taskSaveData"
            :taskNo="processDetail.process?Number(processDetail.process.taskNo): 0"
            :status="(processDetail.process && processDetail.process.status)?processDetail.process.status: 'done'"
          />
          <!-- 流程记录  -->
          <CommentTable
            v-loading="!dataReady"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(153, 153, 153, 0.8)"
            v-if="flowData.length>0"
            :flowData="flowData"
          />          

          <!-- 会签意见区 -->
          <InfoContainer
            v-if="!isStartedProcess"
            class="comment-container"
            style="margin-top:20px;"
            :infoTitle="commentBlockConfig['infoTitle']"
            :contentConfig="commentBlockConfig['infoContent']"
          >
            <template #comment>
              <CommentBlock
                ref="commentBlock"
                @fileChange="fileChange"
                :id='id'
              />
            </template>
          </InfoContainer>          
          <div class="bottom-block" style="width: 100%; height: 30px;"></div>
        </el-tab-pane>

        <el-tab-pane label="流程跟踪" name="fourth" v-if="isStartedProcess">
          <template v-if="activeName == 'fourth'">
            <el-card shadow="never" style="margin-top: 5px;">
              <wf-design ref="bpmn" style="height: 500px;" :options="bpmnOption"></wf-design>
            </el-card>
          </template>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="bottom-container" v-if="!isStartedProcess">
      <div class="button-container">
        <el-button type="primary" @click="validData(false)">保存</el-button>
        <el-button type="primary" plain @click="validData(true)" v-if="!basicInfoData.flowableId">发起流程</el-button>
      </div>
    </div>

    <BottomLine
      v-else
      ref="bottomLine"
      :auditState="basicInfoData.auditStatus"
      :processDetail="processDetail"
      :isStartedProcess="isStartedProcess"
      :buildNew="buildNew"
      @buildNewOne="buildNewOne"
      @startProcess="saveProject('startProcess')"
      @saveTask="saveTask"
      @saveProject="saveProject"
      @flowNext="flowNext"
      @openPrintForm="goPrint"
      @refreshData="refreshData"
    />

  </div>
</template>
<script>
import { addFundInvest, getFundInvestDetail } from '@/api/zg/zg'
import InfoContainer from "@/components/infoContainer/fundInfoContainer";
import Accessory from "@/components/accessoriesother/accessoryFactor"
// 工作流相关组件
import AuditInfo from "@/components/workflowComponents/auditInfo/auditInfo"
import CommonSelect from "@/components/commonSelect/commonSelect"
import CommentStep from "@/components/workflowComponents/commentStep/commentStep"
import CommentTable from "@/components/workflowComponents/commentTable/commentTable"
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import BottomLine from "@/components/workflowComponents/bottomLine/bottomLine"
import { fundInvestAddConfig } from "./config";
import { mapGetters } from "vuex";
import workFlow from '@/mixins/workFlow'
import util from "@/mixins/util"
export default {
  name: 'ZgFundBuildProjectDetail',
  mixins: [workFlow, util],
  data() {
    return {
      id: '',
      projectInfoId: '',
      fileId: '',
      contractId: '',
      processKey: 'process_loan_invest',
      detailFormUrl: '/zg/fund/invest/detail',      
      activeName: 'first',
      isDetail: false,
      basicInfoData: {
        createUser:"",
        fundManager:"",
        name:"",
        planNum:"",
        planValue:"",
        projectType:"",
        remarks:"",
        securitiesName:"",
        securitiesNo:""
      },
      formConfig: fundInvestAddConfig(),
      InfoContainerConfig: {
        infoTitle: '基本信息',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },      
    }
  },
  components: {
    InfoContainer,
    Accessory,
    AuditInfo,
    CommentStep,
    CommentTable,
    BottomLine,
    CommonSelect,
    CommentBlock,
  },
  watch: {
    // '$route.prams.id': {
    //   async handler(val) {
    //     if(val == 1 || val == 2){
    //       this.id = await this.getVirtualID()
    //       this.isStartedProcess = false       
    //     }else{
    //       this.isDetail = true
    //       this.id = val
    //       this.getFactoringDetail(this.id)
    //     }

    //   },
    // }
  },
  computed: {
    ...mapGetters(["workFlowData", "userInfo"]),
  },  
  mounted() {
    this.startProject()
  },
  methods: {
    setProjectData(data) {
      this.fileId = data.projectInfoId
      this.basicInfoData.projectInfoId = data.dzReportVO.dzProjectVO.id
      this.basicInfoData.contractId = data.id
      this.basicInfoData.contractMoney = data.contractMoney
      this.basicInfoData.projectName = data.dzReportVO.dzProjectVO.name
      this.basicInfoData.projectType = `${data.dzReportVO.dzProjectVO.projectType}`
      this.basicInfoData.securitiesName = data.dzReportVO.dzProjectVO.securitiesName
      this.basicInfoData.securitiesNo = data.dzReportVO.dzProjectVO.securitiesNo
      this.basicInfoData.actualValue = data.dzReportVO.actualValue
      this.basicInfoData.actualNum = data.dzReportVO.actualNum
      // this.basicInfoData.planValue = data.planValue
      // this.basicInfoData.planNum = data.planNum
      this.basicInfoData.fundManager = data.dzReportVO.dzProjectVO.fundManager

    },

    async startProject() {
      let id = this.$route.params.id
      if(!id) {
        this.basicInfoData.createUserName = this.userInfo.user_name
        this.basicInfoData.createUser = this.userInfo.user_id
        this.id = await this.getVirtualID()
        this.isStartedProcess = false
        this.getBasicConfigData()
      }else {
        this.id = id
        this.isDetail = true
        this.queryInvestDetail()
      }
    },

    async queryInvestDetail() {
      let res = await getFundInvestDetail({id: this.id})
      if(res.data.code == 200) {
        this.basicInfoData = res.data.data
        // this.projectInfoId = this.basicInfoData.reportId
        this.contractId = this.basicInfoData.dzContractVO.id
        this.planPayDate = this.basicInfoData.planPayDate
        // this.basicInfoData.projectType = `${this.basicInfoData.projectType}`
        this.basicInfoData.createUserName = `${this.basicInfoData.managerUserName}`

        this.setFlowData()
      }
    },

    async setFlowData() {
      // 查询流程数据
      this.$store.commit('SET_WORKFLOW_STATE', {state: this.basicInfoData.auditStatus})
      if(this.basicInfoData.flowableId) {
        this.isStartedProcess = true
        // 集成在workFlow.js中
        await this.queryFlowData(this.basicInfoData.flowableId)
      } else {
        // 未启动流程 查询第一个节点的文件上传权限
        this.processDefinedId = await this.userQueryProcessDefinedId(this.processKey)
        this.permissionList = await this.queryTaskUploadDetail(this.processDefinedId, '', true)
        // 设置流程表单路径
        this.queryProcessFormDetail(this.processDefinedId)
      }

      // 判断页面是否可编辑（1.流程未提交 2.流程详情中isEditable为true可编辑 3.当前为第一步时）
      let presentFlow = this.flowData[this.flowData.length - 1]
      if(this.basicInfoData.auditStatus == 0 || this.processDetail.flow[2].historyActivityId == presentFlow.historyActivityId) {
        this.columnEditChange(true)
      } else {
        this.columnEditChange(false)
      }
    },

    columnEditChange(edit) {
      if(this.userInfo.user_id != this.basicInfoData.managerUser) edit = false
      this.isEditable = edit
      this.formConfig.column.map(item => {
        if(item.prop == 'sellerCustId') {
          return
        }
        if(!item.alwaysDisabled){
          item.disabled = !edit
        }

      })
    },    

    validData(startProcess) {
      let self = this
      this.$refs.basicInfo.validate((valid, done) => {
        if(valid) {
          // 校验通过, 提交数据
          self.submitForm(startProcess)
          done()
        }else{
          let element = document.getElementById('basicForm')
          element.scrollIntoView()
          self.$message({
            type: 'warning',
            message: '请补全基础信息数据'
          })
        }
      })
    },

    async submitForm(startProcess) {
      let msg = this.$route.params.id == 1||this.$route.params.id == 2?'新增成功':'修改成功'
      let processInsId = ''
      let params = {
        id: this.id,
        flowableId: '',
        ...this.basicInfoData
      }
      // let processNameRes = await getPocessName(params) 
      if(startProcess) {
        // 若存在会签意见附件 带入attchment字段
        let redirectInfo ={
          url: this.detailFormUrl,
          id: this.id
        }
        let processParams = {
          detailFormUrl: JSON.stringify(redirectInfo),
          processId: this.processDefinedId,
          comment: this.$refs.commentBlock.$data.opinionContent,
          attachmentList: this.attchmentList,
          // processInstanceName: processNameRes.data.data.processInstanceName
        }
        processInsId = await this.startWorkFlowProcess(processParams)
        // if(processInsId != '') params.flowableId = processInsId
      }
      if(processInsId != '') params.flowableId = processInsId
      let res = await addFundInvest(params)
      if(res.data.code == 200){
        this.queryInvestDetail()
        this.isDetail = true
        this.$router.push({
          path: `/zg/fund/investManage/detail/${this.id}`
        })        
        if(!this.$route.params && this.$route.params.id) {
          this.$store.commit("DEL_TAG", this.tag);
        }
        this.$message({
          message: msg,
          type: 'success'
        })
      }
    },

    // 保存尽调数据
    async saveTask() {
      let taskId = this.processDetail.process.taskId;
      // 从vuex中获取
      let comment = this.workFlowData.opinionContent;
      // let attachmentList = this.workFlowData.attchmentList

      // 流程表单数据
      let customData = this.$refs.auditInfo.commentDetail;
      let formData = this.$refs.auditInfo.$data.formData;

      let variables = this.dealAuditForm(formData, customData);
      // 保存数据存储在variables中
      variables[`comment_${taskId}`] = comment;
      // variables[`attachment_${taskId}`] = attachmentList

      let saveRes = await this.flowSaveTask(variables);
      // 刷新数据
      this.saveTask = {
        comment: "",
        attachment: [],
      };
      this.queryInvestDetail(this.id);
      this.$forceUpdate();
    },

    // 流程流转
    async flowNext(taskInfoList) {
      let processInsId = this.processDetail.process.processInstanceId;
      let taskId = this.processDetail.process.taskId;
      let taskName = this.processDetail.process.taskName;
      let valid = false;
      // 流程表单数据
      if (
        this.$refs.auditInfo.avueFormConfig.column &&
        this.$refs.auditInfo.avueFormConfig.column.length > 0
      ) {
        valid = this.$refs.auditInfo.validData();
      } else {
        valid = true;
      }
      if (valid) {
        let customData = this.$refs.auditInfo.commentDetail;
        let formData = this.$refs.auditInfo.$data.formData;

        let variables = this.dealAuditForm(formData, customData);
        if (taskInfoList) {
          await this.selectPeopleFlowNext(
            taskId,
            taskName,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            variables,
            JSON.stringify(taskInfoList)
          );
        } else {
          let res = await this.taskFlowNext(
            taskId,
            processInsId,
            this.workFlowData.attchmentList
              ? this.workFlowData.attchmentList
              : [],
            this.workFlowData.opinionContent
              ? this.workFlowData.opinionContent
              : "",
            variables
          );
        }

        // 刷新数据
        this.queryInvestDetail(this.id);
        this.$forceUpdate();
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.zg-fund-contract-detail{
  background-color: #fff;
  overflow: hidden auto;
  padding: 15px !important;
  padding-bottom: 30px !important;
  .inner-con{
    min-width: 1100px;
    // max-width: 1100px;
    width: 93%;
    margin: 0 auto;
    margin-top: 3px;
    .project-title{
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }
    .project-status{
      .status-title{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #999999;
        font-size: 14px;
      }
      .status-content{
        text-align: right;
        font-family: '微软雅黑', sans-serif;
        font-weight: 400;
        color: #666666;
        font-size: 20px;
      }
      .stateTopdiv::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        margin-right: 5px;
      }
      .color_0::before {
        background: #fec03d;
      }
      .color_1::before {
        background: #409eff;
      }
      .color_2::before {
        background: #51d351;
      }
      .color_3::before {
        background: #F56C6C;
      }
      .color_4::before {
        background: #F56C6C;
      }
    }
  }
  /deep/.el-tabs__item {
    font-size: 18px ;
    font-weight: bolder ;
    margin-bottom: 10px ;
  }
  /deep/.el-tabs__item.is-active {
    background: none;
  }
  /deep/.el-tabs__header {
    margin: 0px;
  }
  .bottom-container{
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0 , 0.05);
    .button-container{
      width: 92%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }  
}
</style>